import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    maintenanceActive: false,
    authUser: {
      is_employee: false,
      loggedIn: false,
      complete: true,
    },
    showNavigationDrawer: false,
    language: 'de',
    inRegistrationProcess: false,
    predefinedSeason: 'winter',
    fetchFavoritesPending: false,
    updateFavoritePending: false,
    favorites: [],
    fetchNotificationsPending: false,
    updateNotificationPending: false,
    updateNotificationsPending: false,
    notifications: [],
    sendContactFormPending: false,
    registerNewsletterPending: false,
    fetchUserProfilePending: false,
    updateUserProfilePending: false,
    sendPasswordResetPending: false,
    sendPasswordResetMailPending: false,
  },
  actions,
  mutations,
};
